import SiteHeader from "@/pages/home/components/SiteHeader";
import Hero from "@/pages/home/components/Hero";
import FocusSection from "@/pages/home/components/FocusSection";
import GallerySection from "@/pages/home/components/GallerySection";
import RankingSection from "@/pages/home/components/RankingSection";
import ChatRecordsSection from "@/pages/home/components/ChatRecordsSection";
import OverviewSection from "@/pages/home/components/OverviewSection";
import DownloadBanner from "@/pages/home/components/DownloadBanner";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <Hero />
        <FocusSection />
        <GallerySection />
        <RankingSection />
        <ChatRecordsSection />
        <OverviewSection />
        <DownloadBanner />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}